const Payments = {
  stripe: null,
  confirmPayment: async function (charge) {
    if (!charge.confirmed && !charge.error && charge.intent_secret) {
      // confirmCardPayment triggers Stripe's 3D secure confirmation dialog
      try {
        var actionResult = await this.stripe.confirmCardPayment(charge.intent_secret, {
          payment_method: charge.method
        })
        if (actionResult.paymentIntent && actionResult.paymentIntent.status === 'succeeded') {
          return { confirmed: true }
        } else if (actionResult.error) throw new Error(actionResult.error.message)
      } catch (error) {
        console.log('Error handling card confirmation')
        console.log(error)
        charge.error = error
      }
    }
    return charge
  },
  handlePaymentIntent: async function (charge) {
    if (!charge.confirmed && !charge.error && charge.intent_secret) {
      // handleCardAction triggers Stripe's 3D secure confirmation dialog
      try {
        var actionResult = await this.stripe.handleCardAction(charge.intent_secret)
      } catch (error) {
        console.log('Error handling card action')
        console.log(error)
      }
      if (actionResult.error) {
        charge.error = actionResult.error
      }
      return { charge, intent: actionResult.paymentIntent }
    } else return { charge }
  },
  charge: async function ({ confirmOnServer, chargeData }) {
    var charge
    var tries = 0
    // Depending on the user's region/card/payment provider/risk profile,
    // the charge may require an additional 3D secure approval step.
    // Obtain approval and reconfirm the charge until approved,
    // or we get an error, or we exceed a sensible number of attempts.
    while (tries < 3 && (!charge || (!charge.error && !charge.confirmed))) {
      try {
        var chargeResult = await confirmOnServer(chargeData)
        var confirmationResult = await this.handlePaymentIntent(chargeResult.data)
        charge = confirmationResult.charge
        if (confirmationResult.intent) chargeData.payment_intent_id = confirmationResult.intent.id
        else chargeData.payment_intent_id = null
        tries++
      } catch (error) {
        console.log('Error during Stripe charge process')
        console.log(error)
        if (!charge) charge = {}
        charge.error = { message: error.message }
      }
    }
    if (charge.confirmed) return charge
    else if (tries >= 3) {
      charge.error = { message: 'Too many attempts' }
    } else if (!charge.error) {
      charge.error = { message: 'Unknown error when taking payment' }
    }
    return charge
  },
  init: function (key) {
    const script = document.createElement('script')
    script.id = 'stripe-script'
    script.src = 'https://js.stripe.com/v3/'
    script.onload = () => {
      // Stripe global loaded by stripe script
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(key)
    }
    document.querySelector('head').append(script)
  }
}

/* const VueStripePlugin = {
  install(Vue, stripe_key) {
    Vue.prototype.$payments = PaymentsPlugin
    PaymentsPlugin.init(stripe_key)
  }
} */

// export default VueStripePlugin

export default Payments
